module.exports = __webpack_public_path__ + "static/media/Chris_Patten.4a41936d.jpg";